import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {EventsService} from '../events.service';

@Component({
  selector: 'app-nav-bar-menu',
  templateUrl: './nav-bar-menu.component.html',
  styleUrls: ['./nav-bar-menu.component.scss']
})
export class NavBarMenuComponent implements OnInit, AfterViewInit {
  @ViewChild('navContainer') navContainer;

  constructor(private eventsService: EventsService) {
  }

  ngOnInit() {
  }

  isAuthenticated() {
    return this.eventsService.getAuthenticated();
  }

  ngAfterViewInit() {

    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        this.navContainer.nativeElement.className = 'containerNavbar user_logged noTop';
      } else {
        this.navContainer.nativeElement.className = 'containerNavbar user_logged';
      }
    });
  }
}
